/**
 * SectionHead — the Q1/Q2/Q3/Q4/Q5 section banner used across the Briefing
 * tab. Small numbered badge + big headline + optional sub paragraph.
 */

import React from 'react';

export interface SectionHeadProps {
  /** Section label (e.g. "Q1", "Q4"). */
  q: string;
  /** Big section headline. */
  title: React.ReactNode;
  /** Optional sub-paragraph. */
  sub?: React.ReactNode;
  /** Badge background colour. Default navy; override for green/red sections. */
  tone?: string;
}

export const SectionHead: React.FunctionComponent<SectionHeadProps> = ({
  q,
  title,
  sub,
  tone = '#0F172A',
}) => (
  <div style={{ maxWidth: 720, margin: '0 0 26px' }}>
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 12,
      }}
    >
      <span
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: '#fff',
          background: tone,
          borderRadius: 8,
          padding: '4px 9px',
          letterSpacing: '0.02em',
        }}
      >
        {q}
      </span>
    </div>
    <h2
      style={{
        fontSize: 30,
        fontWeight: 600,
        color: '#0F172A',
        letterSpacing: '-0.02em',
        margin: 0,
        lineHeight: 1.12,
      }}
    >
      {title}
    </h2>
    {sub && (
      <p
        style={{
          fontSize: 15.5,
          lineHeight: 1.6,
          color: '#64748B',
          margin: '12px 0 0',
          maxWidth: 680,
        }}
      >
        {sub}
      </p>
    )}
  </div>
);
